export const UTMZ_COOKIE_NAME = '__utmz';
export const YM_COOKIE_NAME = '_ym_uid';
export const GA_COOKIE_NAME = '_ga';
export const CHILD_COOKIE_NAME = 'clid';

export const PRODUCT_LIST_ANCHOR = 'product-list-anchor';
export const PRODUCT_DESCRIPTION_ANCHOR = 'product-description-anchor';
export const TOP_PAGE_ANCHOR = 'top-page-anchor';
